// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"135":"d0486d9a","211":"a0843998","238":"6aad3a08","311":"8bf8aad0","397":"a268dba8","413":"53956477","467":"2d8900b2","479":"54297cb1","482":"6cbf5617","650":"d4294eee","743":"b1baf3f0","815":"1238385b"}[chunkId] + ".chunk.js";
};